import { createLink } from "@tanstack/react-router";

import { ActionPill } from "./ui/action-pill";
import { NotificationRow } from "./ui/notification-row";
import { SectionRow } from "./ui/section-row";

/** ActionPill as a type-safe router link (`to`, `search`, intent preloading, `aria-current`). */
export const ActionPillLink = createLink(ActionPill);

/** NotificationRow with its title as a type-safe router link. */
export const NotificationRowLink = createLink(NotificationRow);

/** SectionRow as a type-safe router link. */
export const SectionRowLink = createLink(SectionRow);
